import { useState } from "react";
import { useAuth } from "../providers/AuthContext";
import { Link, useNavigate } from "react-router-dom";


export default function LoginPage() {
  const [formData, setFormData] = useState({ phone_number: "", password: "" });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    // dispatch({ type: "LOGIN_START" });
    setLoading(true);
    e.preventDefault();
    fetch(`${process.env.REACT_APP_API_URL}login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setUser({
            id: data.data._id,
            name: data.data.name,
            role: data.data.role,
          });
          navigate(`${process.env.PUBLIC_URL}/`);
        } else {
          // dispatch({ type: "LOGIN_FAIL" });
          alert(data.error);
        }
        setLoading(false);
      });
  };

  return (
    <div className="container my-4">
      <div className="card shadow p-4 col-md-6 mx-auto">
        <h2 className="text-center">Login</h2>
        <form onSubmit={handleSubmit} className="py-4">
          <div className="mb-3">
            <label className="form-label">Phone Number</label>
            <input
              type="text"
              name="phone_number"
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="d-flex justify-content-between">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "logging..." : "Login"}
            </button>          
            <Link to={`${process.env.PUBLIC_URL}/ForgotPassword`} className="text-decoration-none">Forgot Password?</Link>
          </div>
          
        </form>
      </div>
    </div>
  );
}
